import { useIsMobile } from "@/hooks/use-mobile";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import moment from "moment";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const useAR360Report = () => {
  const fromDashboard = useLocation().pathname?.includes("/dashboard");
  const isMobile = useIsMobile();
  const [isPropertyView, setIsPropertyView] = useState<boolean>(false);
  const [date, setDate] = useState<any>(moment());

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const {currentFinanceYear} = useSelector(
    (state: RootState) => state.currentData
  );
  
  const breadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.cam}/${
          fromDashboard ? routes.dashboard : routes.activityDashboard
        }`,
        name: `${fromDashboard ? "Dashboard" : "Activity Dashboard"} - ${
          communityDetail?.name || ""
        }`,
      },
      {
        link: "",
        name: <span className="text-primary">Collection 360 Report</span>,
      },
    ],
    []
  );

  const togglePropertyView = () => {
    setIsPropertyView((prev) => !prev);
    // setDate(null);
  };

  return {
    breadcrumbData,
    isMobile,
    togglePropertyView,
    setDate,
    date,
    isPropertyView,
    currentFinanceYear
  };
};

export default useAR360Report;
